// assets/drug-accordion.js

console.log('🔔 drug-accordion.js loaded and running');

document.body.addEventListener('click', function(e) {
  const title = e.target.closest('.accordion-title');
  if (!title) return;
  console.log('▶️ accordion-title clicked:', title.textContent.trim());
  // …以下、元のトグル処理…
  const section = title.closest('.accordion-section');
  const isOpen = title.classList.contains('active');
  section.querySelectorAll('.accordion-title.active')
         .forEach(t => t.classList.remove('active'));
  if (!isOpen) title.classList.add('active');
});


// ページが読み込まれたら即バインド（defer して読み込む想定）
(function() {
  document.body.addEventListener('click', function(e) {
    const title = e.target.closest('.accordion-title');
    if (!title) return;
    const section = title.closest('.accordion-section');
    const isOpen = title.classList.contains('active');
    // 同じセクション内を全部閉じ
    section.querySelectorAll('.accordion-title.active')
           .forEach(t => t.classList.remove('active'));
    // 自分だけトグル開閉
    if (!isOpen) title.classList.add('active');
  });
})();
